import { render, staticRenderFns } from "./StudentDocumentsTab.vue?vue&type=template&id=5b04b777&"
import script from "./StudentDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./StudentDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports